import SideMenu from "../sideMenu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useEffect, useState, useRef } from "react";
import QueryString from "query-string";
import SearchIcon from "@material-ui/icons/Search";
import { TextField, InputAdornment } from "@material-ui/core";
import { Modal, Table, Spinner } from "react-bootstrap";
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  Space,
  Card,
  message,
  DatePicker,
  Button,
  Tabs,
  Typography,
} from "antd";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import config from "../../../config";
import { debounce, sumBy } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import scanimg from "../../image/barcodescan.png";
import { makeStyles } from "@material-ui/core/styles";
import { v4 as uuidv4 } from "uuid";
import FormGroup from "@material-ui/core/FormGroup";
import { Checkbox } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { PlusOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import modalimg from "../../image/itemnotfound.png";
import useLocalStorage from "../../../hooks/useLocalstorage";
import { useLocation } from "react-router-dom";
import { useDebounce } from "../../../hooks/useDebounce";
import autocomplete from "autocompleter";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import DownLoadExcelTemplate from "./downloadExcelTemplate";
import VendorExcelUpload from "./excelUpload";
import { useCountry, useCurrency } from "../../../provider/courtryProvider";
import { useNavigate } from "react-router-dom";
import { PlusOneOutlined } from "@mui/icons-material";
import CustomTabs from "../../tabs";
import dayjs from "dayjs";
import { useAccess } from "../../../provider/AccessProvider";
import { VENDORACCESS } from "../../../utils/constant";

const useStyles = makeStyles((theme) => ({
  formInput: {
    borderRadius: 8,
  },
  formItem: {
    fontWeight: 700,
    "& .ant-col ant-col-24 ant-form-item-label": {
      padding: 0,
    },
  },
  selectInput: {
    "&.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector":
      {
        borderRadius: "0 8px 8px 0",
      },
  },
  unitFormItem: {
    borderRadius: "8px 0 0 8px",
  },
  taxTypeInput: {
    "&.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector":
      {
        borderRadius: 8,
      },
  },
}));

const VendorAddBill = (props) => {
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const classes = useStyles();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [vendorId, setVendorId] = useState("");
  const [val, setVal] = useState("");
  const [productArray, setProductArray] = useState([]);
  const [cursor, setCursor] = useState(0);
  const [productCode, setProductCode] = useState("");
  const [addedProducts, setAddedProducts] = useState([]);
  const [addNewItem, setAddNewItem] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [billConfirm, setBillConfirm] = useState(false);
  const [fullyPaid, setFullyPaid] = useState(false);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [amountReceived, setAmountReceived] = useState("");
  const [pendingAmount, setPendingAmount] = useState(0);
  const [cardType, setCardType] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [billLoading, setBillLoading] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [itemNotFound, setItemNotFound] = useState(false);
  const [activeKey, setActivekey] = useState("1");
  // const [taxList, setTaxList] = useState([]);
  const taxList = useSelector((state) => state.taxList.taxList);
  const [form] = Form.useForm();
  const [currentDraft, setCurrentDraft] = useState(true);
  const [draftBill, setDraftBill] = useLocalStorage("draftBill", []);
  const [_vendorDetails, _setVendorDetails] = useLocalStorage("vendor", {});
  const location = useLocation();
  const vendorDetails = location.state?.data;
  const [isRequired, setIsRequired] = useState(false);
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const { productList: products } = useSelector((state) => state.products);
  const productsForSearch = useSelector((state) => state.productsForSearch);
  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState({});
  const [groupCategory, setGroupCategory] = useState({});
  const inputRef = useRef();
  const access = useAccess(VENDORACCESS);
  const debouncedSearchEanCode = useDebounce(productCode, 500);
  const dispatch = useDispatch();

  const handleRemoveAll = () => {
    setDraftBill([]);
  };

  useEffect(() => {
    if (vendorDetails) {
      _setVendorDetails(vendorDetails);
    }
  }, [_setVendorDetails, vendorDetails]);

  const moveDraftToCurrent = (data) => {
    setInvoiceNo(data.invoiceNumber);
    setAddedProducts([...data.vendors]);
    setCurrentDraft(!currentDraft);
    var filteredArr = draftBill.filter(
      (vendor) => vendor.billId !== data.billId
    );
    setDraftBill([...filteredArr]);
    setCurrentDraft(true);
  };

  const handleDeleteDraftBill = (billId) => {
    var filteredArr = draftBill.filter((data) => data.billId !== billId);
    setDraftBill([...filteredArr]);
  };
  const handleHoldBill = () => {
    if (addedProducts.length === 0) {
      return alert("Nothing added in the bill to hold.");
    }
    if (invoiceNo === "") {
      return alert("Please enter invoice number.");
    }
    var dateTime = new Date().toLocaleTimeString();
    var date = new Date().toISOString().substring(0, 10);
    var dBill = {
      invoiceNumber: invoiceNo,
      billId: uuidv4(),
      vendors: addedProducts,
      vendorName: _vendorDetails?.userName,
      userPhoneNumber: _vendorDetails?.userPhoneNumber,
      billDate: date + " " + dateTime,
      billTotal: getTotalPrice(addedProducts),
      numberOfItems: addedProducts.length,
    };
    console.log("dBill", dBill);
    setDraftBill((prev) => [...prev, dBill]);
    setAddedProducts([]);
    setInvoiceNo("");
    alert("Bill Hold success");
  };

  // useEffect(() => {
  //   console.log(" addedProducts", addedProducts);
  // }, [addedProducts]);

  const handleClose = () => {
    setAddNewItem(false);
    form.resetFields();
  };

  const handleReceivedAmount = (e) => {
    setAmountReceived(e.target.value);
    if (+e.target.value === +balanceAmount) {
      setFullyPaid(true);
    }
  };

  const updateBillBalance = async () => {
    if (!amountReceived) return alert("Please enter amount Paid.");
    if (parseFloat(amountReceived) < 0)
      return alert("Amount Paid should be greater than zero.");
    if (dueDate === "" && pendingAmount > 0) {
      return alert("Please enter due date.");
    }
    if (amountReceived > 0 && !paymentMethod)
      return alert("Please choose mode of payment.");
    if (paymentMethod === "card" && !cardType)
      return alert("Please select card type.");
    if (paymentMethod === "card" && !cardNumber)
      return alert("Please enter last four digit card number.");
    setBillLoading(true);
    const totalPrice = getTotalPrice(addedProducts);
    const taxCredit = getTaxCredit(addedProducts);
    const result = {
      action: "vendorAddBill",
      invoiceNumber: invoiceNo,
      billingDate: dayjs().format("YYYY-MM-DD"),
      dueDate: dueDate ? dayjs(dueDate).format("YYYY-MM-DD") : "",
      totalBillValue: totalPrice,
      amountPaid: parseFloat(amountReceived).toFixed(2),
      remarks: remarks,
      paymentMethod: "cash",
      fullyPaid: fullyPaid,
      balanceAmount: pendingAmount,
      taxCredit: taxCredit,
      items: addedProducts,
      shopId: shopId,
      vendorId: vendorId,
      ...(paymentMethod === "card" && {
        cardType: cardType,
        cardNumber: cardNumber,
      }),
    };
    setBillLoading(true);
    try {
      var res = await fetch(`${config.newApiGateway}/vendor/vendorManagement`, {
        method: "POST",
        body: JSON.stringify(result),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });

      res = await res.json();
      if (res.code === "ERROR") {
        setBillLoading(false);
        return alert(res.message);
      }

      if (res.code === "SUCCESS") {
        navigate({
          pathname: `/dashboard/vendor-management/vendor-details`,
          search: `?id=${vendorId}`,
        });
        getProductDetails(shopId);
        resetToDefault();
      }
    } catch (err) {
      setBillLoading(false);
      alert("Error while update balance. Please try again.");
    } finally {
      setIsRequired(false);
      setBillLoading(false);
    }
  };

  const resetToDefault = () => {
    setBillConfirm(false);
    setBillLoading(false);
    setBalanceAmount(0);
    setAmountReceived("");
    setPendingAmount(0);
    setPaymentMethod("");
    setCardNumber("");
    setCardType("");
    setFullyPaid(false);
  };

  const handleAddBillSubmit = () => {
    if (invoiceNo === "") {
      message.warning("Please enter invoice no");
    } else if (addedProducts.length === 0) {
      message.warning("Please add atleast one item");
    } else {
      var indexArr = [];
      let messages = undefined;
      addedProducts.forEach((data, i) => {
        if (parseFloat(data.productMrp) < parseFloat(data.productPrice)) {
          indexArr.push(i + 1);
          messages = `Selling price should not be greater than MRP for ${data.productName}`;
        } else if (
          parseFloat(data.productMrp) < parseFloat(data.purchasePrice)
        ) {
          indexArr.push(i + 1);
          messages = `Purchase price should not be greater than MRP for ${data.productName}`;
        } else if (data.taxIncExc) {
          if (!data.taxId) {
            messages = `Please add Tax to ${data.productName}`;
          }
        } else if (data.taxId) {
          if (!data.taxIncExc) {
            messages = `Please add service to ${data.productName}`;
          }
        }
        if (!data.productPrice) {
          messages = `Please enter Selling price to ${data.productName}`;
        }
        if (!data.purchasePrice) {
          messages = `Please enter Purchase price to ${data.productName}`;
        }
      });
      messages && message.error(messages);
      if (messages === undefined) {
        const totalAmount = getTotalPrice(addedProducts).toFixed(2);
        setBalanceAmount(totalAmount);
        setBillConfirm(true);
      }
    }
  };

  const getProductDetails = async (shopId) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify({
          userId: shopId,
          type: "getProductDetails",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.limitExceeds && data.status) {
          try {
            var productData = await fetch(data.products);
            productData = await productData.json();
            productData = productData.map((i) => {
              let measurement = {
                measurmentUnit: "",
                measurmentValue: "",
              };
              if (
                data.unitOfMeasurment !== "Others" &&
                i.hasOwnProperty("unitOfMeasurment")
              ) {
                measurement.measurmentUnit = i.unitOfMeasurment.split(" ")[1];
                measurement.measurmentValue = i.unitOfMeasurment.split(" ")[0];
              }
              if (data.unitOfMeasurment === "Others") {
                measurement.measurmentUnit = i.unitOfMeasurment;
                measurement.measurmentValue = i.unitOfMeasurment;
                data.unitOfMeasurment = "";
              }
              return {
                ...i,
                measurmentUnit: measurement.measurmentUnit,
                measurmentValue: measurement.measurmentValue,
              };
            });
            let sortedArr = productData.sort((a, b) => {
              if (a.productName === b.productName) return 0;
              if (a.productName > b.productName) return 1;
              return -1;
            });
            const addToLocalStroage = sortedArr?.map((i) => {
              let label = i.productName;
              if (
                i.unitOfMeasurment !== "Others" &&
                i.unitOfMeasurment !== "" &&
                !i.unitOfMeasurment !== true
              ) {
                label = `${i.productName} (${i.unitOfMeasurment})`;
              }
              return {
                id: i.productId,
                name: label,
                productEANCode: i.productEANCode,
                productCode: i.productCode,
                color: i.color,
                size: i.size,
                value: i.productName.toLowerCase(),
              };
            });
            dispatch({
              type: "SET_PRODUCT_LIST",
              payload: sortedArr,
            });

            dispatch({
              type: "SET_PRODUCTS_SEARCH",
              payload: addToLocalStroage,
            });
            return;
          } catch (err) {
            alert("Failed to fetch product details. Please try again");
            return;
          }
        }
        const updatedProduct = data.products.map((i) => {
          let measurement = {
            measurmentUnit: "",
            measurmentValue: "",
          };
          if (
            i.unitOfMeasurment !== "Others" &&
            i.hasOwnProperty("unitOfMeasurment")
          ) {
            measurement.measurmentUnit = i.unitOfMeasurment.split(" ")[1];
            measurement.measurmentValue = i.unitOfMeasurment.split(" ")[0];
          }
          if (i.unitOfMeasurment === "Others") {
            measurement.measurmentUnit = "";
            measurement.measurmentValue = "";
            i.unitOfMeasurment = "";
          }
          return {
            ...i,
            measurmentUnit: measurement.measurmentUnit,
            measurmentValue: measurement.measurmentValue,
          };
        });
        var sortedArr = updatedProduct.sort((a, b) => {
          if (a.productName === b.productName) return 0;
          if (a.productName > b.productName) return 1;
          return -1;
        });

        const addToLocalStroage = sortedArr?.map((i) => {
          let label = i.productName;
          if (
            i.unitOfMeasurment !== "Others" &&
            i.unitOfMeasurment !== "" &&
            !i.unitOfMeasurment !== true
          ) {
            label = `${i.productName} (${i.unitOfMeasurment})`;
          }
          return {
            id: i.productId,
            name: label,
            productEANCode: i.productEANCode,
            productCode: i.productCode,
            color: i.color,
            size: i.size,
            value: i.productName.toLowerCase(),
          };
        });
        dispatch({
          type: "SET_PRODUCT_LIST",
          payload: sortedArr,
        });
        dispatch({
          type: "SET_PRODUCTS_SEARCH",
          payload: addToLocalStroage,
        });
      })
      .catch((err) => {
        console.log("Err", err);
      })
      .finally(() => {});
  };

  const onFinish = (values) => {
    console.log("values", values);

    const product = getTaxableValueAndTaxs(
      values,
      values.inventoryQty,
      values.purchasePrice
    );

    const result = {
      ...product,
      productPrice: values.productPrice,
      unitOfMeasurment: values.measurementValue + " " + values.measurementUnit,
      productId: uuidv4(),
      addedDate: new Date().toISOString().substring(0, 10),
      shopId: shopId,
      versionId: "1",
      isExist: false,
      inventoryQty: 0,
      latest: "true",
      group: values.group ? values.group : "OTHERS",
      category: values.category ? values.category : "OTHERS",
      subCategory: values.subCategory ? values.subCategory : "OTHERS",
      status: "new",
      productType: "product",
      measurementValue: undefined,
      measurementUnit: undefined,
    };
    addItemHandler({ ...result, isExist: false }, "fromScan");
    setAddNewItem(false);
    setIsRequired(false);
    form.resetFields();
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    form.submit();
  };

  useEffect(() => {
    var rAmount = amountReceived;
    if (!rAmount) rAmount = 0;
    var total = (parseFloat(balanceAmount) - parseFloat(rAmount)).toFixed(2);
    setPendingAmount(total);
    // if (parseFloat(amountReceived) === parseFloat(balanceAmount)) {
    //   setFullyPaid(true);
    // }
  }, [amountReceived, balanceAmount]);

  useEffect(() => {
    let params = QueryString.parse(location.search);
    setVendorId(params.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTaxCredit = (products) => {
    let taxCredit = 0;
    products.forEach((item) => {
      taxCredit +=
        parseFloat(item.cgst) +
        parseFloat(item.sgst) +
        parseFloat(item.igst) +
        parseFloat(item.cess) +
        parseFloat(item.additionalcess);
    });
    return taxCredit;
  };

  const getTotalPrice = (products) => {
    let result = sumBy(products, (i) => +i.totalPrice);
    return result;
  };

  const getTotalCess = (products) => {
    let result = sumBy(products, (i) => +i.cess || 0);
    return result;
  };

  const getTotalIGST = (products) => {
    let result = sumBy(products, (i) => +i.igst || 0);
    return result;
  };
  const getTotalAdditionalCess = (products) => {
    let result = sumBy(products, (i) => +i.additionalcess || 0);
    return result;
  };

  const getTotalByTaxType = (products, type) => {
    let result = sumBy(products, (i) => +i?.[type] || 0);
    return result;
  };

  const getTotalCGST = (products) => {
    let result = sumBy(products, (i) => +i.cgst || 0);
    console.log("result12", products, result);
    return result;
  };

  const getTotalSGST = (products) => {
    let result = sumBy(products, (i) => +i.sgst || 0);
    return result;
  };

  const getTotalTaxableValue = (products) => {
    let result = sumBy(products, (i) => +i.taxableValue || 0);
    return result;
  };

  const hanldeKeydown = (e) => {
    if (e.keyCode === 38 && cursor > 0) {
      setCursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < productArray.length - 1) {
      setCursor(cursor + 1);
    }
    if (e.keyCode === 13) {
      let currentItem = productArray[cursor];
      if (currentItem !== undefined) {
        addItemHandler({ ...currentItem, count: 1, isExist: true }, "fromScan");
        setProductArray([]);
        setVal("");
      }
    }
  };

  const updateExsistingProduct = (productId, product) => {
    let taxableValue = 0;
    let taxs = {};
    let selectedTax = {};
    let totalTaxPercentage = 0;
    let itemTotal = 0;
    const count = product.count + 1;
    if (product.taxId && product.taxId !== "Select Tax") {
      selectedTax = taxList.find(
        (data) => data.taxId.toString() === product.taxId.toString()
      );
      console.log("taxListSelectedTax", taxList, selectedTax);
      totalTaxPercentage = selectedTax.taxType.reduce((acc, curr) => {
        const taxTypeName =
          customTaxType.find((customTax) => customTax.taxId === curr)
            ?.taxName || curr;
        return acc + parseFloat(selectedTax[taxTypeName] || 0);
      }, 0);
      taxableValue = taxableValueFunc(
        product.purchasePrice,
        totalTaxPercentage,
        count,
        product.taxIncExc
      );
      taxs = taxTypeFunc(taxableValue, selectedTax, product.taxIncExc);
    } else {
      itemTotal = product.purchasePrice * count;
    }
    const updateProduct = {
      ...product,
      ...taxs,
      taxMaster: selectedTax,
      count: count,
      totalPrice: taxs.totalPrice || itemTotal,
    };
    return updateProduct;
  };

  const handleOnSelect = (item) => {
    getRelatedProducts(item.id);
    setVal("");
  };

  const formatResult = (item) => {
    return (
      <div
        style={{
          padding: "1rem 0.75rem",
          borderBottom: "1px solid gray",
        }}
        key={item.value}
      >
        <span className="result-span">{item.name}</span>
      </div>
    );
  };

  const addItemHandler = (product, from) => {
    console.log(product, "product11");
    let tempProductId = product.productId;
    let purchasePrice = product.purchasePrice || 0;
    let productTax = product.productTax || 0;
    let taxIncExc = product.taxIncExc;
    let selectedTax = {};
    let totalTaxPercentage = 0;
    let count = product.count;

    setAddedProducts((prev) => {
      console.log("prev", prev, prev?.length);
      let existingProduct;
      if (prev?.length > 0) {
        existingProduct = prev.find(
          (data) => data?.productId === tempProductId
        );
      }
      if (existingProduct?.productId) {
        const updatedProduct = updateExsistingProduct(
          existingProduct.productId,
          existingProduct
        );
        return prev.map((i) => {
          if (i.productId === tempProductId) {
            return updatedProduct;
          }
          return i;
        });
      } else {
        if (product.taxId && product.taxId !== "Select Tax") {
          selectedTax = taxList.find(
            (data) => data.taxId.toString() === product.taxId.toString()
          );

          console.log("selectedTax22", selectedTax, taxList, product);

          totalTaxPercentage = selectedTax?.taxType?.reduce((acc, curr) => {
            const taxTypeName =
              customTaxType.find((customTax) => customTax.taxId === curr)
                ?.taxName || curr;
            return acc + parseFloat(selectedTax[taxTypeName] || 0);
          }, 0);
        }

        const taxableValue = taxableValueFunc(
          purchasePrice,
          totalTaxPercentage,
          count,
          taxIncExc
        );

        let taxs = taxTypeFunc(taxableValue, selectedTax, product.taxIncExc);
        let newAddedProducts = {
          ...product,
          ...taxs,
          tasMaster: selectedTax,
          purchasePrice: purchasePrice,
          taxIncExc: taxIncExc,
          taxableValue: parseFloat(taxableValue || 0).toFixed(2),
        };

        return [newAddedProducts, ...prev];
      }
    });
  };

  // const searchProductFromDb = async (from, searchKey) => {
  //   try {
  //     var res = await fetch(`${config.ApiGateway1}/v1/search/products`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         shopId,
  //         from: from,
  //         searchKey: searchKey,
  //       }),
  //     });
  //     res = await res.json();
  //     if (res.code === "ERROR") {
  //       return [];
  //     }
  //     return res.data;
  //   } catch (err) {
  //     console.log("Err", err);
  //     return [];
  //   }
  // };

  const getRelatedProducts = (productId) => {
    const getProduct = products.find((i) => {
      return productId === i.productId;
    });
    console.log("getRelatedProducts", productId);
    addItemHandler({ ...getProduct, count: 1, isExist: true }, "fromScan");
  };

  const deleteItemHandler = (key) => {
    setAddedProducts((items) => items.filter((data) => data.productId !== key));
  };

  const taxableValueFunc = (purchasePrice, productTax, count, taxIncExc) => {
    let result;
    if (taxIncExc === "inclusive") {
      result =
        (purchasePrice / (100 + parseFloat(productTax || 0))) *
        parseFloat(count || 0) *
        100;
    } else if (taxIncExc === "exclusive") {
      result = purchasePrice * parseFloat(count || 0);
    } else {
      result = purchasePrice * count;
    }
    return result || 0;
  };

  const taxTypeFunc = (taxableValue, selectedTax, taxType) => {
    console.log("taxableValue", taxableValue, selectedTax, taxType);
    const customTaxValue = {};
    const getTaxType = {
      cgst: undefined,
      sgst: undefined,
      igst: undefined,
      cess: undefined,
      additionalcess: undefined,
    };
    customTaxType.forEach((i) => {
      getTaxType[i.taxName] = undefined;
    });

    selectedTax?.taxType?.forEach((tax) => {
      const taxTypeName =
        customTaxType.find((customTax) => customTax.taxId === tax)?.taxName ||
        tax;
      customTaxValue[taxTypeName] =
        (customTaxValue[taxTypeName] || 0) +
        parseFloat(
          taxableValue * (parseFloat(selectedTax[taxTypeName] || 0) / 100)
        );
    });

    const sumOfTax = Object.values(customTaxValue).reduce(
      (acc, cur) => acc + cur,
      0
    );
    const itemTotal = parseFloat(taxableValue) + sumOfTax;
    return {
      ...getTaxType, // reinitialize
      ...customTaxValue,
      cgst: customTaxValue?.["gst"] / 2,
      sgst: customTaxValue?.["gst"] / 2,
      taxId: selectedTax.taxId,
      taxIncExc: taxType ? taxType : "inclusive",
      taxType: Object.keys(customTaxValue),
      itemTotal,
      totalPrice: itemTotal,
      taxableValue,
      totalBeforeTax: taxableValue,
    };
  };

  const memorizedArray = (value) => {
    const cache = {};
    let result;

    if (cache[value] !== undefined) {
      result = cache[value];
    } else {
      const productValue = productsForSearch.find((i) => {
        return i?.eanCode?.toLowerCase() === value.toLowerCase();
      });
      if (productValue) {
        cache[value] = productValue;
        result = productValue;
      } else {
        result = "Not Found";
      }
    }
    return result;
  };

  useEffect(
    () => {
      if (productCode === "TBA") {
        alert("UPDATE EAN CODE");
      } else if (debouncedSearchEanCode && productCode !== "") {
        const product = memorizedArray(productCode);
        if (product?.id) {
          getRelatedProducts(product.id, "fromScan");
          setProductCode("");
        } else if (product === "Not Found") {
          setItemNotFound(true);
        }
      }
    },
    [debouncedSearchEanCode, productCode] // Only call effect if debounced search term changes
  );

  const getTaxableValueAndTaxs = (product, quantity, purchasePrice) => {
    let productObj;
    let taxableValue = 0;
    let taxs = {};
    let selectedTax = {};
    let totalTaxPercentage = 0;
    let itemTotal = 0;
    if (
      product.taxId &&
      product.taxId !== "Select Tax" &&
      product.taxIncExc &&
      product.taxIncExc !== "Inclusive/Exclusive"
    ) {
      selectedTax = taxList.find(
        (data) => data.taxId.toString() === product.taxId.toString()
      );
      totalTaxPercentage = selectedTax.taxType.reduce((acc, curr) => {
        const taxTypeName =
          customTaxType.find((customTax) => customTax.taxId === curr)
            ?.taxName || curr;
        return acc + parseFloat(selectedTax[taxTypeName] || 0);
      }, 0);
      taxableValue = taxableValueFunc(
        purchasePrice,
        totalTaxPercentage,
        quantity,
        product.taxIncExc
      );
      console.log("taxableValue121", taxableValue);
      taxs = taxTypeFunc(taxableValue, selectedTax, product.taxIncExc);
    } else {
      itemTotal = parseFloat(purchasePrice || 0) * parseFloat(quantity || 0);
    }
    productObj = {
      ...product,
      ...taxs,
      totalPrice: taxs.totalPrice || itemTotal,
      taxableValue: taxableValue.toFixed(2),
    };
    return productObj;
  };

  const handleExcelUploadProduct = (values) => {
    const updateProduct = values.map((item) => {
      const product = getTaxableValueAndTaxs(
        item,
        item.inventoryQty,
        item.purchasePrice
      );
      return product;
    });
    setAddedProducts((prev) => [...prev, ...updateProduct]);
  };

  const handleBillingInputChange = (key, value, product, index) => {
    let productObj;
    let taxableValue = 0;
    let taxs;
    let selectedTax = {};
    let totalTaxPercentage = 0;
    let tempProduct = "";
    addedProducts.forEach((obj) => {
      if (obj.productId === product.productId) {
        tempProduct = obj;
      }
    });

    if (tempProduct.taxId && tempProduct.taxId !== "Select Tax") {
      const id = key === "taxId" ? value : tempProduct.taxId;
      selectedTax = taxList.find(
        (data) => data.taxId.toString() === id.toString()
      );
      totalTaxPercentage = selectedTax?.taxType?.reduce((acc, curr) => {
        const taxTypeName =
          customTaxType.find((customTax) => customTax.taxId === curr)
            ?.taxName || curr;
        return acc + parseFloat(selectedTax[taxTypeName] || 0);
      }, 0);
    }
    if (key === "count") {
      taxableValue = taxableValueFunc(
        product.purchasePrice,
        totalTaxPercentage,
        value,
        product.taxIncExc
      );
      let tempTax = product.taxIncExc ? product.taxIncExc : "inclusive";
      taxs = taxTypeFunc(taxableValue, selectedTax, tempTax);
    } else if (key === "purchasePrice") {
      taxableValue = taxableValueFunc(
        value,
        totalTaxPercentage,
        product.count,
        product.taxIncExc
      );
      let tempTax = product.taxIncExc ? product.taxIncExc : "inclusive";
      taxs = taxTypeFunc(taxableValue, selectedTax, tempTax);
    } else if (key === "taxId") {
      console.log(
        "taxList",
        taxList,
        customTaxType,
        key,
        value,
        product,
        index
      );
      selectedTax = taxList.find(
        (data) => data.taxId.toString() === value.toString()
      );
      totalTaxPercentage = selectedTax?.taxType?.reduce((acc, curr) => {
        const taxTypeName =
          customTaxType.find((customTax) => customTax.taxId === curr)
            ?.taxName || curr;
        return acc + parseFloat(selectedTax[taxTypeName] || 0);
      }, 0);
      taxableValue = taxableValueFunc(
        product.purchasePrice,
        totalTaxPercentage,
        product.count,
        product.taxIncExc ? product.taxIncExc : "inclusive"
      );
      let tempTax = product.taxIncExc ? product.taxIncExc : "inclusive";
      taxs = taxTypeFunc(taxableValue, selectedTax, tempTax);
    } else if (key === "taxIncExc") {
      console.log("product", product, addedProducts);

      if (tempProduct.taxId && tempProduct.taxId !== "Select Tax") {
        taxableValue = taxableValueFunc(
          product.purchasePrice,
          totalTaxPercentage,
          product.count,
          value
        );

        let tempTax = product.taxIncExc ? product.taxIncExc : "inclusive";

        taxs = taxTypeFunc(
          taxableValue,
          selectedTax,
          product.taxIncExc,
          tempTax
        );
      } else {
        return message.warning("Please select tax first");
      }
    }
    // Get product from ProductList
    const getProduct = products.find((i) => i.productId === product.productId);
    console.log("getProduct", getProduct);
    productObj = {
      ...product,
      ...taxs,
      tasMaster: selectedTax,
      [key]: value,
    };
    console.log("productObj", productObj);
    productObj = {
      ...productObj,
      ...(!productObj?.taxId && {
        taxIncExc: "",
      }),
      ...(!productObj?.taxIncExc && {
        taxId: "",
      }),
    };
    console.log("productObj1212", productObj, taxs);
    let filteredArr = addedProducts.filter(
      (data) => data.productId !== product.productId
    );
    filteredArr = [
      ...filteredArr.slice(0, index),
      productObj,
      ...filteredArr.slice(index),
    ];
    setAddedProducts([...filteredArr]);
  };

  console.log("addedProducts121", addedProducts);

  const handleCheckBoxChange = (e) => {
    const value = e.target.checked;
    if (value) {
      setAmountReceived(balanceAmount);
      setFullyPaid(value);
      setPendingAmount(0);
    } else {
      setAmountReceived(0);
      setFullyPaid(value);
      setPendingAmount(balanceAmount);
    }
  };

  const handleSearch = (v) => {
    setVal(v);
  };

  useEffect(() => {
    if (shopDetails.shopId === "") return;
    // if (
    //   shopDetails.empId &&
    // )
    //   return props.navigate("/dashboard/overview");
    if (
      shopDetails.shopType === "Supermarket" ||
      shopDetails.shopType === "Provisional Store"
    ) {
      (async function () {
        var json = await fetch(config.productCategory);
        json = await json.json();
        console.log("json", json);
        // setCategoryList(json.groups);
        setGroupCategory(json.groups);
      })();
    } else {
      if (Object.keys(shopDetails.categoryList).length <= 0) {
        var list = {
          OTHERS: {
            subCategory: ["OTHERS"],
            imageUrl: "",
          },
        };
        setCategoryList(list);
      } else setCategoryList(shopDetails.categoryList);
    }
  }, [shopDetails]);

  useEffect(() => {
    console.log("addedProducts", addedProducts);
  }, [addedProducts]);

  return (
    <>
      <Card
        bodyStyle={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        style={{
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 20,
          }}
          className="invoice-generator-head-btn2"
        >
          <div
            style={{
              height: 40,
            }}
            className="invoice-generator-head-textfield"
          >
            <ReactSearchAutocomplete
              items={productsForSearch}
              onSelect={handleOnSelect}
              styling={{
                borderRadius: 4,
                boxShadow: "none",
                zIndex: 100,
              }}
              formatResult={formatResult}
              placeholder="Search items by typing product name or code"
              showIcon={false}
              showClear={false}
              maxResults={10}
              inputSearchString={val}
              onSearch={handleSearch}
              fuseOptions={{
                shouldSort: true,
                threshold: 0.6,
                location: 0,
                distance: 75,
                minMatchCharLength: 1,
                keys: ["name", "productCode"],
                includeMatches: false,
              }}
            />
          </div>
          <Input
            id="scannerInput"
            onChange={(e) => {
              setProductCode(e.target.value);
            }}
            placeholder="Place your cursor here and start scanning the product"
            prefix={<QrCodeScannerIcon />}
            value={productCode}
            style={{
              width: "400px",
            }}
            size="large"
            onBlur={() => setProductArray([])}
          />
          <div className="product-table-header-invoice">
            <Input
              style={{
                width: "150px",
                borderRadius: 4,
              }}
              placeholder="Enter a Invoice No"
              size="large"
              value={invoiceNo}
              onChange={(e) => setInvoiceNo(e.target.value)}
            />
          </div>
        </div>
        <div>
          <Button
            type="link"
            onClick={() => {
              if (!access.addProductItems()) {
                return;
              }
              setAddNewItem(true);
            }}
          >
            + Add New Item
          </Button>
        </div>
      </Card>
      <div>
        <CustomTabs
          tabBarExtraContent={
            <>
              {activeKey === "1" && (
                <>
                  <VendorExcelUpload onChange={handleExcelUploadProduct} />
                  <DownLoadExcelTemplate />
                </>
              )}
              {activeKey === "2" && (
                <Button onClick={handleRemoveAll} type="primary">
                  Remove All
                </Button>
              )}
            </>
          }
          activeKey={activeKey}
          onTabChange={(v) => setActivekey(v)}
        >
          <Tabs.TabPane tab="Current" key={"1"}>
            <div className="product-table" style={{ background: "#feffff" }}>
              <div
                className="product-table-header"
                style={{ background: "#feffff" }}
              >
                <div className="product-table-header-order">
                  <p>Order Items ({addedProducts?.length || 0})</p>
                </div>
                {/* <div className="product-table-header-invoice">
                  Invoice No:{" "}
                  <Input
                    style={{
                      width: "150px",
                      height: "30px",
                      border: "1px solid #ccc",
                    }}
                    placeholder="Enter a Invoice number"
                    size="small"
                    value={invoiceNo}
                    onChange={(e) => setInvoiceNo(e.target.value)}
                  />
                </div> */}
              </div>
              {addedProducts?.length > 0 ? (
                <Table responsive="md">
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                      background: "#E5E5E5",
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Item
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Product MRP({country.CurrencySymbol})
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Selling Price({country.CurrencySymbol})
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Purchase Price({country.CurrencySymbol})
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                          textAlign: "center",
                        }}
                      >
                        Tax
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Exclusive/Inclusive
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        SGST({country.CurrencySymbol})
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        CGST({country.CurrencySymbol})
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        IGST({country.CurrencySymbol})
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        CESS({country.CurrencySymbol})
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Additional CESS({country.CurrencySymbol})
                      </th>
                      {customTaxType?.map((type) => {
                        return (
                          <th
                            style={{
                              verticalAlign: "middle",
                              fontWeight: "500",
                            }}
                          >
                            {type.label}({country.CurrencySymbol})
                          </th>
                        );
                      })}
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Taxable Value
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      >
                        Total Price
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          fontWeight: "500",
                        }}
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    {addedProducts.map((data, index) => {
                      return (
                        <tr
                          key={data?.productId}
                          className="align-items-center"
                          style={{
                            background: "#feffff",
                            verticalAlign: "middle",
                          }}
                        >
                          <td style={{ verticalAlign: "middle" }}>
                            <div className="productname-input">
                              <p>{data?.productName}</p>
                              <h6>{data?.unitOfMeasurment}</h6>
                            </div>
                          </td>
                          <td
                            style={{
                              verticalAlign: "middle",
                              textAlign: "left",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                borderBottom: "0.2px dashed #000000",
                                width: "80px",
                                backgroundColor: "white",
                              }}
                            >
                              <input
                                placeholder="Product Mrp"
                                style={{
                                  width: "80px",
                                }}
                                value={data?.productMrp || 0}
                                type="number"
                                name="productMrp"
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) =>
                                  handleBillingInputChange(
                                    e.target.name,
                                    e.target.value,
                                    data,
                                    index
                                  )
                                }
                              />
                            </div>
                          </td>
                          <td
                            style={{
                              verticalAlign: "middle",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                borderBottom: "0.2px dashed #000000",
                                width: "80px",
                                backgroundColor: "white",
                              }}
                            >
                              <input
                                placeholder="Price"
                                style={{
                                  width: "80px",
                                }}
                                value={data.productPrice}
                                type="number"
                                name="productPrice"
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) =>
                                  handleBillingInputChange(
                                    e.target.name,
                                    e.target.value,
                                    data,
                                    index
                                  )
                                }
                              />
                            </div>
                          </td>
                          <td
                            style={{
                              verticalAlign: "middle",
                            }}
                          >
                            <p style={{ textAlign: "left" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  borderBottom: "0.2px dashed #000000",
                                  width: "80px",
                                  backgroundColor: "white",
                                }}
                              >
                                <input
                                  placeholder="Price"
                                  style={{
                                    width: "80px",
                                  }}
                                  value={data.purchasePrice}
                                  type="number"
                                  name="purchasePrice"
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(e) =>
                                    handleBillingInputChange(
                                      e.target.name,
                                      e.target.value,
                                      data,
                                      index
                                    )
                                  }
                                />
                              </div>
                            </p>
                          </td>

                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                borderBottom: "0.2px dashed #000000",
                                width: "50px",
                                backgroundColor: "white",
                              }}
                            >
                              <input
                                placeholder="Qty"
                                value={data.count}
                                name="count"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) =>
                                  handleBillingInputChange(
                                    e.target.name,
                                    e.target.value,
                                    data,
                                    index
                                  )
                                }
                              />
                            </div>
                          </td>

                          <td
                            style={{
                              verticalAlign: "middle",
                            }}
                          >
                            <select
                              name="taxId"
                              style={{
                                fontSize: 15,
                                marginRight: 10,
                                height: "32px",
                                width: "160px",
                              }}
                              value={data.taxId}
                              onChange={(e) => {
                                handleBillingInputChange(
                                  e.target.name,
                                  e.target.value,
                                  data,
                                  index
                                );
                              }}
                              placeholder="Select Tax"
                            >
                              <option value="">Select Tax</option>
                              {taxList.map((tax, index) => {
                                return (
                                  <option key={index} value={tax.taxId}>
                                    {tax.taxName}
                                  </option>
                                );
                              })}
                            </select>
                          </td>
                          {console.log("data34", data)}
                          <td
                            style={{
                              verticalAlign: "middle",
                            }}
                          >
                            <select
                              name="taxIncExc"
                              style={{
                                fontSize: 15,
                                marginRight: 10,
                                height: "32px",
                                width: "100%",
                              }}
                              value={data.taxIncExc}
                              defaultValue={""}
                              onChange={(e) =>
                                handleBillingInputChange(
                                  e.target.name,
                                  e.target.value,
                                  data,
                                  index
                                )
                              }
                            >
                              <option value="">Inclusive/Exclusive </option>
                              <option value={"inclusive"}>Inclusive</option>
                              <option value={"exclusive"}>Exclusive</option>
                            </select>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "50px",
                                backgroundColor: "white",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {data.gst ? currencyFormatter(data.cgst) : "Nil"}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "50px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {data.gst ? currencyFormatter(data.sgst) : "Nil"}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "50px",
                                backgroundColor: "white",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {data.igst ? currencyFormatter(data.igst) : "Nil"}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "50px",
                                backgroundColor: "white",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {data.cess ? currencyFormatter(data.cess) : "Nil"}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "50px",
                                backgroundColor: "white",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {" "}
                              {data.additionalcess
                                ? currencyFormatter(data.additionalcess)
                                : "Nil"}
                            </div>
                          </td>
                          {customTaxType?.map((type) => {
                            return (
                              <td style={{ verticalAlign: "middle" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "50px",
                                    backgroundColor: "white",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {data?.[type.taxName]
                                    ? currencyFormatter(data[type.taxName])
                                    : "Nil"}
                                </div>
                              </td>
                            );
                          })}
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {currencyFormatter(data.taxableValue)}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {currencyFormatter(data.totalPrice)}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => deleteItemHandler(data.productId)}
                            >
                              <DeleteIcon />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <div className="noItemDiv">
                  <div className="noItemimg">
                    <img
                      src={scanimg}
                      width="50px"
                      height="51px"
                      alt="scanImag"
                    />
                  </div>
                  <p className="noItemText" style={{ marginTop: 0 }}>
                    Start adding your purchase items by scanning / inventory
                    search or add them directly.
                  </p>
                </div>
              )}
            </div>
            <div>
              <Button
                className="holdBtn"
                style={{
                  margin: "0.5rem 0",
                }}
                onClick={handleHoldBill}
              >
                Hold Bill
              </Button>
            </div>
            <Row
              style={{
                marginTop: "2px",
                backgroundColor: "#fff",
                padding: "20px 16px",
              }}
              gutter={[20, 20]}
            >
              <Col span={4}>
                <Space direction="vertical">
                  <h5
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    Total CGST
                  </h5>
                  <Typography.Text type="secondary">
                    {currencyFormatter(getTotalCGST(addedProducts))}
                  </Typography.Text>
                </Space>
              </Col>
              <Col span={4}>
                <Space direction="vertical">
                  <h5
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    {" "}
                    Total SGST
                  </h5>
                  <Typography.Text type="secondary">
                    {" "}
                    {currencyFormatter(getTotalSGST(addedProducts))}
                  </Typography.Text>
                </Space>
              </Col>
              <Col span={4}>
                <Space direction="vertical">
                  <h5
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    {" "}
                    Total IGST
                  </h5>
                  <Typography.Text type="secondary">
                    {" "}
                    {currencyFormatter(getTotalIGST(addedProducts))}
                  </Typography.Text>
                </Space>
              </Col>
              <Col span={4}>
                <Space direction="vertical">
                  <h5
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    {" "}
                    Total CESS
                  </h5>
                  <Typography.Text type="secondary">
                    {" "}
                    {currencyFormatter(getTotalCess(addedProducts))}
                  </Typography.Text>
                </Space>
              </Col>
              <Col span={4}>
                <Space direction="vertical">
                  <h5
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    {" "}
                    Total Additional Cess
                  </h5>
                  <Typography.Text type="secondary">
                    {" "}
                    {currencyFormatter(getTotalAdditionalCess(addedProducts))}
                  </Typography.Text>
                </Space>
              </Col>
              {customTaxType.map((type) => {
                return (
                  <Col span={4}>
                    <Space direction="vertical">
                      <h5
                        style={{
                          fontSize: "16px",
                        }}
                      >
                        {type.label}
                      </h5>
                      <Typography.Text type="secondary">
                        {currencyFormatter(
                          getTotalByTaxType(addedProducts, type.taxName)
                        )}
                      </Typography.Text>
                    </Space>
                  </Col>
                );
              })}
              <Col span={4}>
                <Space direction="vertical">
                  <h5
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    Total Taxable Value
                  </h5>
                  <Typography.Text type="secondary">
                    {currencyFormatter(getTotalTaxableValue(addedProducts))}
                  </Typography.Text>
                </Space>
              </Col>
              <Col span={4}>
                <Space direction="vertical">
                  <h4
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    Total Price
                  </h4>
                  <Typography.Text type="secondary">
                    {" "}
                    {currencyFormatter(getTotalPrice(addedProducts))}
                  </Typography.Text>
                </Space>
              </Col>
            </Row>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                type="primary"
                onClick={() =>
                  navigate({
                    pathname: `/dashboard/vendor-management/vendor-details`,
                    search: `?id=${vendorId}`,
                  })
                }
                ghost
              >
                Cancel
              </Button>
              <Button
                style={{
                  marginLeft: 20,
                }}
                type="primary"
                onClick={() => {
                  if (!access.addBillVendor()) {
                    return;
                  }
                  handleAddBillSubmit();
                }}
              >
                Add Bill
              </Button>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab={`Draft (${draftBill.length})`} key={"2"}>
            <div className="product-table" style={{ background: "#feffff" }}>
              {draftBill.length > 0 ? (
                <Table>
                  <thead>
                    <tr>
                      <th>Created At</th>
                      <th>Mobile No.</th>
                      <th>Name</th>
                      <th>Item Count</th>
                      <th>Amount({country.CurrencySymbol})</th>
                      <th>Actions</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {draftBill.map(
                      (data) =>
                        data?.vendorName === _vendorDetails?.userName && (
                          <tr
                            style={{
                              background: "#feffff",
                            }}
                          >
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  textAlign: "left",
                                }}
                              >
                                <p>{data.billDate}</p>
                              </div>
                            </td>
                            <td style={{ textAlign: "left" }}>
                              <p>{data.userPhoneNumber} </p>
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "left",
                                }}
                              >
                                <p>{data?.vendorName}</p>
                              </div>
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "left",
                                }}
                              >
                                <p>{data.numberOfItems}</p>
                              </div>
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "left",
                                }}
                              >
                                <p>{currencyFormatter(data.billTotal)}</p>
                              </div>
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "left",
                                }}
                              >
                                <button
                                  className="holdBtn"
                                  style={{ width: "150px" }}
                                  onClick={() => moveDraftToCurrent(data)}
                                >
                                  Move to Billing
                                </button>
                              </div>
                            </td>
                            <td>
                              <div
                                style={{
                                  cursor: "pointer",
                                  textAlign: "left",
                                }}
                                onClick={() =>
                                  handleDeleteDraftBill(data.billId)
                                }
                              >
                                <DeleteIcon className="deleteIcon" />
                              </div>
                            </td>
                          </tr>
                        )
                    )}
                  </tbody>
                </Table>
              ) : (
                <div className="noItemDiv">
                  <p className="noItemText" style={{ marginTop: 30 }}>
                    <>No Data to Display</>
                  </p>
                </div>
              )}
            </div>
          </Tabs.TabPane>
        </CustomTabs>
      </div>
      <Modal
        show={addNewItem}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <div>
            <h3 style={{ color: "#EF4667" }}>Add Item to Bill</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            onFinish={onFinish}
            form={form}
          >
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Item Name"
                  name={"productName"}
                  className={classes.formItem}
                  rules={[
                    {
                      required: true,
                      message: "Please enter item name",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    className={classes.formInput}
                    placeholder="Product Name"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Item HSN"
                  name={"productHsnCode"}
                  className={classes.formItem}
                >
                  <Input
                    size="large"
                    placeholder="Product HSN Code"
                    className={classes.formInput}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Item Code"
                  name={"productEANCode"}
                  className={classes.formItem}
                >
                  <Input
                    size="large"
                    placeholder="Product EAN Code"
                    className={classes.formInput}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  label="Product MRP"
                  name={"productMrp"}
                  className={classes.formItem}
                  rules={[
                    {
                      required: true,
                      message: "Please enter product MRP",
                    },
                    {
                      pattern: /^[0-9]*$/,
                      message: "Please enter valid MRP",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    className={classes.formInput}
                    placeholder="Product MRP"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Purchase Price"
                  name={"purchasePrice"}
                  className={classes.formItem}
                  rules={[
                    {
                      required: true,
                      message: "Please enter Purchase Price",
                    },
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: "Please enter valid Purchase Price",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    className={classes.formInput}
                    placeholder="Product Rate"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Selling Price"
                  name={"productPrice"}
                  className={classes.formItem}
                  rules={[
                    {
                      required: true,
                      message: "Please enter Selling Price",
                    },
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: "Please enter valid Selling Price",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    className={classes.formInput}
                    placeholder="Selling Price"
                  />
                </Form.Item>
              </Col>
              {(shopDetails.shopType === "Supermarket" ||
                shopDetails.shopType === "Provisional Store") && (
                <Col span={8}>
                  <Form.Item
                    label="Group"
                    name={"group"}
                    className={classes.formItem}
                    rules={[
                      {
                        required: true,
                        message: "Please Select group",
                      },
                    ]}
                    shouldUpdate={(prev, current) => {
                      if (prev.group !== current.group) {
                        form.setFieldValue("category", "");
                        form.setFieldValue("subCategory", "");
                      }
                      return prev.group !== current.group;
                    }}
                  >
                    <Select
                      size="large"
                      style={{
                        borderRadius: 10,
                      }}
                    >
                      {Object.keys(groupCategory || {}).map((key) => {
                        return (
                          <Select.Option key={key} value={key}>
                            {key}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              {shopDetails.shopType === "Supermarket" ||
              shopDetails.shopType === "Provisional Store" ? (
                <Col span={8}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prev, current) => {
                      if (prev.group !== current.group) {
                        form.setFieldValue("subCategory", "");
                        form.setFieldValue("category", "");
                      }
                      return prev.group !== current.group;
                    }}
                  >
                    {({ getFieldValue }) => {
                      return (
                        <>
                          {getFieldValue("group") ? (
                            <Form.Item
                              label="Category"
                              name={"category"}
                              className={classes.formItem}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select category",
                                },
                              ]}
                            >
                              <Select size="large">
                                {(
                                  getFieldValue("group") &&
                                  Object.keys(
                                    groupCategory[getFieldValue("group")]
                                      ?.category
                                  )
                                )?.map((i) => {
                                  return (
                                    <Select.Option key={i} value={i}>
                                      {i}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          ) : (
                            <Form.Item
                              label="Category"
                              name={"category"}
                              className={classes.formItem}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select  category",
                                },
                              ]}
                            >
                              <Select size="large"></Select>
                            </Form.Item>
                          )}
                        </>
                      );
                    }}
                  </Form.Item>
                </Col>
              ) : (
                <Col span={8}>
                  <Form.Item
                    label="Category"
                    name={"category"}
                    className={classes.formItem}
                    rules={[
                      {
                        required: true,
                        message: "Please select category",
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      style={{
                        borderRadius: 10,
                      }}
                    >
                      {Object.keys(categoryList || {}).map((key) => {
                        return (
                          <Select.Option key={key} value={key}>
                            {key}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              {shopDetails.shopType === "Supermarket" ||
              shopDetails.shopType === "Provisional Store" ? (
                <Col span={8}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prev, current) => {
                      if (prev.category !== current.category) {
                        form.setFieldValue("subCategory", "");
                      }
                      return prev.category !== current.category;
                    }}
                  >
                    {({ getFieldValue }) => {
                      return (
                        <>
                          {getFieldValue("category") ? (
                            <Form.Item
                              label="Sub Category"
                              name={"subCategory"}
                              className={classes.formItem}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select sub category",
                                },
                              ]}
                            >
                              <Select size="large">
                                {getFieldValue("group") &&
                                  groupCategory[
                                    getFieldValue("group")
                                  ].category[
                                    getFieldValue("category")
                                  ]?.subCategory?.map((i) => {
                                    return (
                                      <Select.Option key={i} value={i}>
                                        {i}
                                      </Select.Option>
                                    );
                                  })}
                              </Select>
                            </Form.Item>
                          ) : (
                            <Form.Item
                              label="Sub Category"
                              name={"subCategory"}
                              className={classes.formItem}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select sub category",
                                },
                              ]}
                            >
                              <Select size="large"></Select>
                            </Form.Item>
                          )}
                        </>
                      );
                    }}
                  </Form.Item>
                </Col>
              ) : (
                <Col span={8}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prev, current) => {
                      if (prev.category !== current.category) {
                        form.setFieldValue("subCategory", "");
                      }
                      return prev.category !== current.category;
                    }}
                  >
                    {({ getFieldValue }) => {
                      return (
                        <>
                          {getFieldValue("category") ? (
                            <Form.Item
                              label="Sub Category"
                              name={"subCategory"}
                              className={classes.formItem}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select sub category",
                                },
                              ]}
                            >
                              <Select size="large">
                                {(
                                  getFieldValue("category") &&
                                  categoryList[getFieldValue("category")]
                                )?.subCategory?.map((i) => {
                                  return (
                                    <Select.Option key={i} value={i}>
                                      {i}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          ) : (
                            <Form.Item
                              label="Sub Category"
                              name={"subCategory"}
                              className={classes.formItem}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select sub category",
                                },
                              ]}
                            >
                              <Select size="large"></Select>
                            </Form.Item>
                          )}
                        </>
                      );
                    }}
                  </Form.Item>
                </Col>
              )}

              <Col span={8}>
                <Form.Item
                  label="Quantity"
                  name={"count"}
                  className={classes.formItem}
                  rules={[
                    {
                      required: true,
                      message: "Please enter quantity",
                    },
                    {
                      pattern: /^[0-9]*$/,
                      message: "Please enter valid quantity",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Enter a Quantity"
                    className={classes.formInput}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="Unit"
                  name={"measurementValue"}
                  className={classes.formItem}
                  rules={[
                    {
                      required: true,
                      message: "Please enter Unit value",
                    },
                    {
                      pattern: /^[0-9]*$/,
                      message: "Please enter valid Unit value",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Unit Per Piece"
                    className={classes.unitFormItem}
                  />
                </Form.Item>
              </Col>
              <Col
                span={3}
                style={{
                  marginLeft: "-16px",
                }}
              >
                <Form.Item
                  name={"measurementUnit"}
                  className={classes.unitFormItem}
                  style={{ marginTop: "40px" }}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Unit",
                    },
                  ]}
                >
                  <Select size="large" className={classes.selectInput}>
                    <Select.Option value="g">g</Select.Option>
                    <Select.Option value="kg">kg</Select.Option>
                    <Select.Option value="mg">mg</Select.Option>
                    <Select.Option value="ml">ml</Select.Option>
                    <Select.Option value="L">L</Select.Option>
                    <Select.Option value="cup">cup</Select.Option>
                    <Select.Option value="count">count</Select.Option>
                    <Select.Option value="box">box</Select.Option>
                    <Select.Option value="pkt">pkt</Select.Option>
                    <Select.Option value="glass">glass</Select.Option>
                    <Select.Option value="cm">cm</Select.Option>
                    <Select.Option value="m">m</Select.Option>
                    <Select.Option value="km">km</Select.Option>
                    <Select.Option value="min">min</Select.Option>
                    <Select.Option value="hour">hour</Select.Option>
                    <Select.Option value="days">days</Select.Option>
                    <Select.Option value="ton">Ton</Select.Option>
                    <Select.Option value="inch">inch</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Tax"
                  name={"taxId"}
                  className={classes.formItem}
                  rules={[
                    {
                      required: isRequired,
                      message: "Please Select a Tax",
                    },
                  ]}
                >
                  <Select
                    size="large"
                    className={classes.taxTypeInput}
                    placeholder="Select a Tax"
                    onChange={(e) => {
                      if (e) {
                        setIsRequired(true);
                      } else {
                        setIsRequired(false);
                      }
                    }}
                    allowClear
                  >
                    {taxList.map((tax, index) => {
                      return (
                        <Select.Option key={index} value={tax.taxId}>
                          {tax.taxName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Inclusive/Exclusive"
                  name={"taxIncExc"}
                  className={classes.formItem}
                  rules={[
                    {
                      required: isRequired,
                      message: "Please Select a Inclusive/Exclusive",
                    },
                  ]}
                >
                  <Select
                    size="large"
                    placeholder="Select a Inclusive/Exclusive"
                    onChange={(e) => {
                      if (e) {
                        setIsRequired(true);
                      } else {
                        setIsRequired(false);
                      }
                    }}
                    allowClear
                  >
                    <Select.Option value="inclusive">Inclusive</Select.Option>
                    <Select.Option value="exclusive">Exclusive</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="cancelButton" onClick={handleClose}>
            Cancel
          </button>
          <button className="addAddrButton" onClick={handleSubmit}>
            ADD ITEM
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={billConfirm}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="billConfirmModalContainer">
            <div className="billConfirmLeftContainer">
              <p className="totalAmountStyle">Total Amount</p>
              <p className="priceStyle"> {currencyFormatter(balanceAmount)}</p>
              <FormGroup
                style={{
                  marginLeft: "20px",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={fullyPaid}
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Full amount Paid"
                />
              </FormGroup>
            </div>
            <div
              className="billConfirmRightContainer"
              style={{
                paddingLeft: "2rem",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p className="recievedTextStyle">Amount paid</p>
              <input
                className="amountStyle"
                onChange={handleReceivedAmount}
                value={amountReceived}
                disabled={fullyPaid}
                type="number"
                style={{
                  width: "100%",
                }}
              />
              <div style={{ height: 25 }}></div>
              <p className="recievedTextStyle">
                {pendingAmount > 0 && <>Pending Amount</>}
              </p>
              <p className="discountStyle">
                {pendingAmount > 0 && <>{currencyFormatter(pendingAmount)}</>}
              </p>
              <div className="paymentDetails">
                {pendingAmount > 0 && (
                  <div className="paymentDetails-name">
                    <p>Due date for Pending Amount</p>
                    <DatePicker
                      format={"DD-MM-YYYY"}
                      value={dueDate}
                      onChange={(v) => setDueDate(v)}
                      disabledDate={(current) => {
                        let customDate = dayjs().format("YYYY-MM-DD");
                        return (
                          current && current < dayjs(customDate, "YYYY-MM-DD")
                        );
                      }}
                      style={{
                        width: "100%",
                        border: "1px solid #909090",
                      }}
                      size="large"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className="paymentDetails"
            style={{ margin: "10px 10px 0px 20px" }}
          >
            <div className="paymentDetails-name">
              <p>Remark</p>
            </div>
            <TextArea
              value={remarks}
              onChange={(v) => setRemarks(v.target.value)}
            />
          </div>

          <div
            className="paymentDetails"
            style={{ margin: "10px 0px 0px 20px" }}
          >
            <div className="paymentDetails-name">
              <p>Payment Method</p>
            </div>
            <div className="paymentDetails-group">
              <RadioGroup
                row
                aria-label="gender"
                name="methods"
                className="group"
                style={{ fontSize: 13, marginTop: -5, marginLeft: 5 }}
              >
                <FormControlLabel
                  value="cash"
                  control={<Radio style={{ color: "#5194c6" }} />}
                  label="Cash Amount"
                  onClick={() => setPaymentMethod("cash")}
                  checked={paymentMethod === "cash"}
                />
                <FormControlLabel
                  value="upi"
                  control={<Radio style={{ color: "#5194c6" }} />}
                  label="UPI Pay"
                  onClick={() => setPaymentMethod("upi")}
                  checked={paymentMethod === "upi"}
                />
                <FormControlLabel
                  value="card"
                  control={<Radio style={{ color: "#5194c6" }} />}
                  label="Debit/Credit"
                  onClick={() => setPaymentMethod("card")}
                  checked={paymentMethod === "card"}
                />
              </RadioGroup>
            </div>
          </div>
          <div>
            {paymentMethod === "card" && (
              <div
                className="billConfirmCardRightContainer"
                style={{
                  marginBottom: "20px",
                }}
              >
                <p className="paymentDetails-name">Card Details</p>
                <p className="cardTypeText">Card Type</p>
                <Select
                  value={cardType}
                  onChange={(v) => setCardType(v)}
                  style={{ width: "100%" }}
                >
                  <Select.Option value="">Choose card type</Select.Option>
                  <Select.Option value="visa">Visa</Select.Option>
                  <Select.Option value="masterCard">Master Card</Select.Option>
                  <Select.Option value="rupay">Rupay</Select.Option>
                </Select>
                <div style={{ height: 8 }}></div>
                <p className="cardTypeText">Card Number</p>
                <Input
                  value={cardNumber}
                  onChange={(e) => setCardNumber(e.target.value)}
                  type="text"
                  placeholder="Enter last 4 digit number"
                />
              </div>
            )}
          </div>
          {!billLoading ? (
            <div className="rowButton">
              <button
                disabled={billLoading}
                onClick={() => resetToDefault()}
                className="leftButtonStyle"
              >
                Cancel
              </button>
              <button
                disabled={billLoading}
                className="rightButtonStyle"
                onClick={() => updateBillBalance()}
              >
                Confirm
              </button>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                margin: "20px 0px 20px 0px",
              }}
            >
              <Spinner animation="border" variant="secondary" />
            </div>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={itemNotFound}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setItemNotFound(false);
          setProductCode("");
        }}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div style={{ textAlign: "center", padding: 0 }}>
            <div className="height12"></div>
            <div className="height12"></div>
            <img src={modalimg} width="30px" height="24px" />
            <div className="height12"></div>
            <p className="notfoundtext">Item Not Found</p>
            <p className="scannedtext">Scanned Item Code : {productCode}</p>
            <p className="addItemalert">
              Do you want to add this item to your inventory
            </p>
            <div className="height12"></div>
            <div className="height12"></div>
            <div className="rowButton">
              <button
                onClick={() => {
                  setItemNotFound(false);
                  setProductCode("");
                }}
                className="rightborder"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setAddNewItem(true);
                  setItemNotFound(false);
                }}
              >
                Add Item
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VendorAddBill;
